module.exports = __webpack_public_path__ + "static/media/btn_bobble_reveal.beac20f0.svg";